export default function Kmeans() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">K-means</h1>
      <p>Content for K-means goes here.</p>
    </div>
  );
}
